import React, { useEffect, Suspense, lazy } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import ScrollToTop from './components/ScrollToTop';
import "./theme.css";

// Import critical pages directly (no lazy loading) for instant display
import Home from "./pages/Home/Home";
import Service from "./pages/Services/Service";
import Products from "./pages/Products/Products";
import AboutVardaan from "./pages/About Vardaan/About Vardaan";
import Resources from "./pages/Resources/Resources";
import NewsandEvents from "./pages/News and Events/NewsandEvents";
import NewsDetail from "./pages/News and Events/NewsDetail";
import GetInTouch from "./pages/Contact Us/Contact Us";
import GroupCompanies from "./pages/Group Companies/Group Companies";
import FostHR from "./pages/FostHR/FostHR";
import ConsortiumPartners from "./pages/Consortium Partners/ConsortiumPartners";
import RiskaVaire from "./pages/GRC/GRC";
import Victaa from "./pages/lapsec/Lapsec";
import Blog from "./pages/Blog/Blog";
import BlogPost from "./pages/Blog/BlogPost";
import Newsroom from "./pages/Newsroom/Newsroom";
import Nvidia from "./pages/Newsroom/Nvidia";
import Intechsante from "./pages/Newsroom/Intechsante";
import SiliconIndia from "./pages/Newsroom/SiliconIndia";
// Lazy load less frequently visited pages
const Privacy = lazy(() => import("./pages/Information/Privacy/Privacy"));
const Cookie = lazy(() => import("./pages/Information/Cookie/Cookie"));
const Terms = lazy(() => import("./pages/Information/Terms/Terms"));
const Data = lazy(() => import("./pages/Information/Data/Data"));
const International = lazy(() => import("./pages/Information/International/International"));
const AdminDashboard = lazy(() => import("./pages/Admin/AdminDashboard"));
const VardaanOfferings = lazy(() => import("./pages/VardaanOfferings"));

// Loading component
const PageLoader = () => (
  <div style={{ 
    display: 'flex', 
    justifyContent: 'center', 
    alignItems: 'center', 
    minHeight: '60vh',
    fontSize: '18px',
    color: '#666'
  }}>
    Loading...
  </div>
);

function App() {
  // Defer Google Analytics loading - don't block initial page load
  useEffect(() => {
    // Wait for page to be interactive before loading analytics
    const loadAnalytics = () => {
      // Load Google Analytics script
      const script = document.createElement('script');
      script.async = true;
      script.defer = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=G-39DM8W8NY3';
      document.head.appendChild(script);

      // Initialize gtag
      window.dataLayer = window.dataLayer || [];
      function gtag(){window.dataLayer.push(arguments);}
      window.gtag = gtag;

      gtag('js', new Date());
      gtag('config', 'G-39DM8W8NY3');

      // Track page views on route changes
      const handleRouteChange = () => {
        gtag('config', 'G-39DM8W8NY3', {
          page_path: window.location.pathname + window.location.search
        });
      };

      // Listen for route changes
      window.addEventListener('popstate', handleRouteChange);
      
      return () => {
        window.removeEventListener('popstate', handleRouteChange);
      };
    };

    // Load analytics after page is interactive (non-blocking)
    if (document.readyState === 'complete') {
      // Page already loaded, load analytics immediately
      loadAnalytics();
    } else {
      // Wait for page to be fully loaded
      window.addEventListener('load', loadAnalytics, { once: true });
    }
  }, []);

  return (
    <Router basename="/vardaanglobal">
      <ScrollToTop />
      <div style={{ position: 'relative', minHeight: '100vh' }}>
        <Navbar />
        <Suspense fallback={<PageLoader />}>
          <Switch>
            <Route exact path="/" component={Home} />
            <Route path="/services" component={Service} />
            <Route path="/products" component={Products} />
            <Route path="/about" component={AboutVardaan} />
            <Route path="/contact" component={GetInTouch} />
            <Route path="/resources" component={Resources} />
            <Route exact path="/news-events" component={NewsandEvents} />
            <Route path="/news-events/:slug" component={NewsDetail} />
            <Route path="/group-companies" component={GroupCompanies} />
            <Route path="/fost-hr" component={FostHR} />
            <Route path="/consortium-partners" component={ConsortiumPartners} />
            {/* <Route path="/Riskavaire" component={RiskaVaire} />
            <Route path="/Victaa" component={Victaa} /> */}
            <Route path="/blog/:slug" component={BlogPost} />
            <Route exact path="/blog" component={Blog} />
            <Route path="/newsroom/nvidia-inception" component={Nvidia} />
            <Route path="/newsroom/intechsante" component={Intechsante} />
            <Route path="/newsroom/siliconindia" component={SiliconIndia} />
            <Route exact path="/newsroom" component={Newsroom} />
            <Route path="/admin-dashboard" component={AdminDashboard} />
            <Route path="/privacy-policy" component={Privacy} />
            <Route path="/cookie-policy" component={Cookie} />
            <Route path="/terms-of-service" component={Terms} />
            <Route path="/data-retention-policy" component={Data} />
            <Route path="/international-data-transfers" component={International} />
            <Route path="/VardaanOfferings" component={VardaanOfferings} />
          </Switch>
        </Suspense>
      </div>
    </Router>
  );
}

export default App;
